import { render } from "./communityq_content_type_field.vue?vue&type=template&id=18324641&lang=pug"
import script from "./communityq_content_type_field.vue?vue&type=script&lang=js"
export * from "./communityq_content_type_field.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__